import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, OperatorFunction, ReplaySubject, firstValueFrom, tap } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { HeaderConfig } from '../../models';

@Injectable({ providedIn: 'root' })
export class HeaderSettingsService {
    private readonly http = inject(HttpClient);

    private readonly _settings: ReplaySubject<HeaderConfig> = new ReplaySubject<HeaderConfig>(1);
    public readonly settings: Observable<HeaderConfig> = this._settings.asObservable();

    public get settingsSubject(): ReplaySubject<HeaderConfig> {
        return this._settings;
    }

    public initializeApp(
        headerSettingsMapper: (appSettings: unknown) => HeaderConfig,
        appSettingsPath = 'assets/appsettings.json'
    ): Promise<HeaderConfig> {
        return firstValueFrom(
            this.http.get<unknown>(appSettingsPath).pipe(
                map(headerSettingsMapper),
                tap((settings) => this._settings.next(settings)),
                catchError((e) => {
                    console.error('Failed to load header settings from appsettings.json', e);
                    throw e;
                })
            )
        );
    }

    public get<T>(operator: OperatorFunction<HeaderConfig, T>): Observable<T> {
        return this.settings.pipe(take(1), operator);
    }
}
